export const Colors = {
  dark: {
    palette_black: "#1A2027",
    green: "#009317",
    red: "#FA3E3E",
    orange: "#fc8019",
    gray: "#808080",
    black: "#000",
    yellow: "rgb(107, 92, 31)",
    blue: "#57ACFF",
    purple: "#58565e"
  },
  light: {
    white: "#fff",
    green: "#E5F4E7",
    red: "#FEEBEB",
    yellow: "#FFFFE0",
    blue: "#EEF6FF",
    purple: "#DFDAEB",
  },
};
